<script lang="ts">
	import type { SbImage } from '../types';
	import Image from '../components/image.svelte';
	import Video from '$lib/video.svelte';
	import { checkVisibility } from '$lib/actions/checkVisibility';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			text: string;
			subtext: string;
			thumbnail: SbImage;
			playback_id: string;
		}>['content'];
		index: number;
	}

	let { content, index }: Props = $props();

	let showVideo = $state(false);

	const threshold = 0.6;

	let videoElement = $state<HTMLVideoElement>();
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<article
	use:editable={content}
	use:checkVisibility={{ threshold }}
	class="group relative shrink-0 max-lg:aspect-[0.8] lg:w-[60vw]"
	onmouseenter={() => {
		if (videoElement) {
			videoElement.currentTime = 0;
		}
	}}
	onvisible={({ detail }) => (showVideo = detail)}
>
	<div class="relative h-full w-full overflow-hidden rounded-[20px] lg:rounded-3xl">
		<div class="relative z-0 h-full w-full">
			<Video
				{threshold}
				bind:videoElement
				wrapperClass="h-full w-full"
				class="h-full w-full"
				playbackId={content.playback_id}
			/>
		</div>

		<Image
			wrapperClass="absolute z-10 inset-0 h-full w-full transition-opacity max-lg:delay-200 duration-300 lg:group-hover:opacity-0 {showVideo
				? 'max-lg:opacity-0'
				: ''}"
			class="h-full w-full object-cover"
			src={content.thumbnail.filename}
			alt={content.thumbnail.alt}
			title={content.thumbnail.title}
			width={430}
			sizes={{
				430: { width: 860 },
				1024: { width: 1850 },
				1536: { width: 2040 }
			}}
		/>

		<div class="absolute bottom-0 left-0 z-10 text-pretty p-5 text-white lg:p-8">
			<h1 class="text-[36px]/[112%] tracking-[-.36px] lg:text-[48px]/[110%] lg:tracking-[-.48px]">
				{content.text}
			</h1>
			<p
				class="mt-1 text-[16px]/[140%] tracking-[-.16px] lg:mt-3 lg:max-w-[70%] lg:text-[20px]/[140%] lg:tracking-[-.2px]"
			>
				{content.subtext}
			</p>
		</div>
		<div
			class="absolute left-0 top-0 z-10 p-5 font-rhymes text-[36px]/[78%] tracking-[-0.72px] text-white lg:p-8 lg:text-[64px]/[100%] lg:tracking-[-1.28px]"
		>
			{index + 1}
		</div>
	</div>
</article>
